import routes from './routes'
import { Fetch } from '../fetch'

class UserService {
  addUser (payload) {
    return Fetch('post', routes.ADD_DEMO, payload)
  }
}

export default new UserService()
